import { atom } from 'jotai';

// Why the login popup was opened: its title and its text depend on it.
type AuthReason =
  | 'like'
  | 'favorite'
  | 'follow'
  | 'comment'
  | 'commentLike'
  | 'profile'
  | 'feedTabs'
  | 'filterGame'
  | 'filterMode'
  | 'filterWeapon'
  | 'ranking'
  | 'login'
  | 'signup'
  | 'signupInvite';

type AuthView = 'login' | 'signup' | 'signupInvite';

interface AuthModal {
  reason: AuthReason;
  view: AuthView;
  // Name shown in the title (ex: the creator to follow).
  username?: string;
}

const authModalAtom = atom<AuthModal | null>(null);

export type { AuthModal, AuthReason, AuthView };

export { authModalAtom };
